import {AxiosInstance} from "axios";
import LeadStatus from "../model/lead/LeadStatus";
import LeadStatusSettings from "../model/lead/LeadStatusSetting";
import {UpdateLeadStatusSettingsApiDto} from "./model/rest";

/**
 * Api for lead status.
 */
export default class LeadStatusApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch lead statuses.
	 * @returns {Promise<LeadStatus[]>} Promise containing all job statuses.
	 */
	fetchLeadStatuses(): Promise<LeadStatus[]> {
		const url = `/api/web/leads/statuses`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(LeadStatus.fromJson));
	}

	/**
	 * Update lead status sort order.
	 * @returns {Promise<LeadStatus[]>}
	 * @param leadStatuses
	 */
	updateSortOrder(leadStatuses: LeadStatus[]) {
		const url = `/api/web/leads/statuses/order`;
		const jobStatusesIds = leadStatuses.map(js => js.id);
		return this.axiosInstance.put(url, jobStatusesIds);
	}

	/**
	 * Edit lead status action.
	 */
	editLeadStatus(leadStatusId: string, data: LeadStatus): Promise<LeadStatus> {
		const url = `/api/web/leads/statuses/${leadStatusId}`;
		return this.axiosInstance.put(url, data.toJson()).then(resp => LeadStatus.fromJson(resp.data));
	}

	/**
	 * Fetch lead statuses settings
	 * @returns {Promise<LeadStatusSettings[]>}
	 */
	fetchLeadStatusConfig(): Promise<LeadStatusSettings[]> {
		const url = `/api/web/leads/statuses/settings`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(LeadStatusSettings.fromJson));
	}

	/**
	 * Update lead status settings
	 * @returns {Promise<LeadStatusSettings[]>}
	 */
	updateLeadStatusConfig(data: UpdateLeadStatusSettingsApiDto): Promise<any> {
		const url = `/api/web/leads/statuses/settings`;
		return this.axiosInstance.put(url, data);
	}
}
